export default "__VITE_ASSET__d5b922fc__"